import { delay } from 'lodash';
import service from '@/service/service';
import { WX_CONFIG_FAILED, DEFAULT_SHARE_IMG } from './constants';

let configStatus = 'notActivated'; // notActivated pending succeed failed
let config$ = null;
let location$ = null;

function getConfig() {
    const option = {
        url: `/index/wxConfigSig`,
        method: 'get',
        data: { url: window.location.href }
    };
    return service(option, option.url).then(result => result);
}

function ready() {
    const ready$ = new Promise((resolve, reject) =>
        config().then(
            wx.ready(() => {
                console.log('wx ready', configStatus);
                if (configStatus === 'failed') {
                    // wx.config失败也会触发wx.ready https://blog.csdn.net/y_bccl27/article/details/100786569
                    return reject({ code: WX_CONFIG_FAILED });
                }
                configStatus = 'succeed';
                return resolve();
            })
        )
    );
    const delay$ = new Promise((_, reject) => delay(() => reject(), 2000));

    return Promise.race([ready$, delay$]);
}

async function config() {
    // 未配置
    if (configStatus === 'notActivated') {
        config$ = getConfig().then(sigOption => {
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: sigOption.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
                timestamp: sigOption.timestamp, // 必填，生成签名的时间戳
                nonceStr: sigOption.noncestr, // 必填，生成签名的随机串
                signature: sigOption.signature, // 必填，签名
                jsApiList: [
                    'checkJsApi',
                    'openLocation',
                    'getLocation',
                    'updateAppMessageShareData',
                    'updateTimelineShareData',
                    'onMenuShareAppMessage',
                    'onMenuShareTimeline'
                ] // 必填，需要使用的JS接口列表，所有JS接口列
            });
            wx.error(res => {
                configStatus = 'failed';
                console.log('wx error:  ', res);
            });
        });
        configStatus = 'pending';
        return config();
    }
    // 获取配置中
    if (configStatus === 'pending') {
        return config$;
    }
    // 已配置
    if (configStatus === 'succeed') {
        return Promise.resolve();
    }
    // 配置失败
    if (configStatus === 'failed') {
        return Promise.reject();
    }
}

function getLocation() {
    return ready().then(() => {
        if (!location$) {
            location$ = new Promise((resolve, reject) => {
                wx.getLocation({
                    type: 'gcj02',
                    success: data => {
                        resolve({
                            lat: data.latitude,
                            lng: data.longitude
                        });
                    },
                    fail: err => {
                        reject(err);
                    },
                    cancel: err => {
                        reject(err);
                    },
                    complete: () => {
                        location$ = null;
                    }
                });
            });
        }
        return location$;
    });
}

function configShare(share) {
    const data = {
        title: share.title || share.product_title || 'NIO 蔚来', // 分享标题
        desc: share.desc || share.product_description, // 分享描述
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl:
            share.imgUrl ||
            share.imageUrl ||
            share.product_image_url ||
            DEFAULT_SHARE_IMG // 分享图标
    };
    return ready().then(() => {
        wx.updateAppMessageShareData(data);
        wx.updateTimelineShareData(data);
    });
}

function hideMenuItems(menuList) {
    return ready().then(() => {
        wx.hideMenuItems({
            menuList: menuList || [
                'menuItem:share:appMessage',
                'menuItem:share:timeline',
                'menuItem:share:qq',
                'menuItem:share:weiboApp',
                'menuItem:share:facebook',
                'menuItem:share:QZone'
            ]
        });
    });
}

export { getLocation, configShare, hideMenuItems };



// WEBPACK FOOTER //
// ./src/util/platform/wx.js